<script>
import { Line, mixins } from "vue-chartjs";
var moment = require("moment");

const { reactiveProp } = mixins;

Chart.defaults.scale.gridLines.display = false; //

export default {
  name: "LineChartFree",
  extends: Line,
  mixins: [reactiveProp],
  props: ["chartData", "titulo"],
  data() {
    return {
      options: {
        maintainAspectRatio: false,
        layout: {
          padding: {
            bottom: 0
          }
        },
        legend: {
          display: true,
          position: "bottom"
        },
        title: {
          display: true,
          text: this.titulo
        },
        responsive: true,
        scales: {
          xAxes: [
            {
              ticks: {
                callback: (value, index, values) => {
                  var x = Math.ceil(values.length / 24);
                  if (index % x == 0) return value;
                }
              },
              gridLines: { display: false }
            }
          ],
          yAxes: [
            {
              display: true,
              ticks: {
                beginAtZero: true
              }
            }
          ]
        },
        hover: {
          mode: "nearest",
          intersect: true
        },
        tooltips: {
          callbacks: {
            label: function(tooltipItem, data) {
              var dataset = data.datasets[tooltipItem.datasetIndex];
              var currentValue = dataset.data[tooltipItem.index];

              return currentValue;
            }
          }
        }
      }
    };
  },
  mounted() {
    this.renderChart(this.chartData, this.options);
  },
  watch: {
    chartData: () => {
      try {
        this.renderChart(this.chartData, this.options);
      } catch (error) {
      }
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/charts/LineChartFree.vue